/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Err_Phone_MinInputs */

const vi_cdo_err_phone_min = /** @type {(inputs: Cdo_Err_Phone_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại tối thiểu 8 ký tự`)
};

/**

* @param {Cdo_Err_Phone_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_err_phone_min = /** @type {((inputs?: Cdo_Err_Phone_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Err_Phone_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_err_phone_min(inputs)
});